import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Rocket } from "lucide-react";
import { api } from "@/lib/api";

const EN = ["Discover Your Ideas", "Choose Your Idea", "Create Your First Offer", "Test Customer Interest", "Plan Your Next Steps"];
const when = (iso) => new Date(iso).toLocaleString("en-GB", { weekday: "short", day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });

export function ChallengeHomeCard() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/challenge/state").then((r) => setS(r.data)).catch(() => {}); }, []);
  if (!s) return null;
  const done = s.enrolled ? s.days.filter((d) => d.state === "completed").length : 0;
  const nx = s.enrolled ? s.next : { day: 1, state: "available" };
  const paid = s.tier !== "free";
  const label = !nx ? "View my Idea Brief" : nx.state === "available" ? (done ? `Continue Day ${nx.day}` : "Start Day 1") : "Open my challenge";
  const to = !nx || nx.state !== "available" ? "/dashboard/challenge" : s.enrolled ? `/challenge/day/${nx.day}` : "/dashboard/challenge";
  return (
    <section className="rounded-3xl bg-[#13283A] text-white p-5" data-testid="home-challenge-card">
      <div className="flex items-center justify-between gap-3">
        <div className="text-xs font-extrabold text-[#13B698] flex items-center gap-1.5"><Rocket className="h-4 w-4" />5-DAY CHALLENGE</div>
        <div className="text-xs font-bold text-white/70" data-testid="home-challenge-progress">{done}/5 days</div>
      </div>
      <div className="mt-2 flex gap-1.5">{[1, 2, 3, 4, 5].map((n) => <span key={n} className={`h-1.5 flex-1 rounded-full ${n <= done ? "bg-[#13B698]" : "bg-white/15"}`} />)}</div>
      <h2 className="font-display font-extrabold text-lg mt-3 leading-snug" data-testid="home-challenge-title">{nx ? `Day ${nx.day}: ${EN[nx.day - 1]}` : "Challenge complete — your Idea Brief is ready"}</h2>
      {nx && nx.state !== "available" && nx.unlock_at && <p className="text-sm text-white/75 mt-1" data-testid="home-challenge-unlock">Next day opens {when(nx.unlock_at)}</p>}
      <p className="text-xs text-white/60 mt-1">{paid ? "Your plan gives you instant access to all 5 days." : "Free • one new day 24 hours after you finish the previous one."} Lessons are in French.</p>
      <Link to={to} className="mt-4 w-full sm:w-auto min-h-[50px] px-5 rounded-2xl bg-[#13B698] font-extrabold inline-flex items-center justify-center gap-2" data-testid="home-challenge-btn">{label} <ArrowRight className="h-5 w-5" /></Link>
    </section>
  );
}
